<template>
  <div>
    <div class="followup-main" v-if="followupList.length">
      <div class="tabel-label">
        <div class="time">跟进时间</div>
        <div class="followupdata">跟进内容</div>
      </div>
      <div class="tabel-label tabel-main" v-for="item in followupList">
        <div class="time">{{ item.createTime }}</div>
        <div class="followupdata">
          <span>{{ item.content }}</span>
          <div class="imgs" v-if="item.imgList">
            <template v-for="(it, index) in item.imgUrl.split(',')">
              <el-image
                v-if="imgOrVideo(it).type == 'img'"
                v-for="it in item.imgList.split(',')"
                :src="imgOrVideo(it).url"
                :preview-src-list="setPreviewList(item.imgList.split(','))"
              >
              </el-image>
              <el-image
                style="cursor: pointer"
                v-if="imgOrVideo(it).type == 'video'"
                v-for="it in item.imgList.split(',')"
                :src="imgOrVideo(it).url"
                @click="openVideo(it)"
              ></el-image>
              <audio
                v-if="imgOrVideo(it).type == 'audio'"
                controls
                :src="imgOrVideo(it).url"
              ></audio>
              <a
                v-if="imgOrVideo(it).type == 'download'"
                :href="imgOrVideo(it).url"
                target="_blank"
                >媒体下载</a
              >
            </template>
          </div>
        </div>
        <div class="operate">
          <a @click="editRemark(item)">编辑</a>
          <el-divider direction="vertical"></el-divider>
          <a @click="handleRemove(item)">删除</a>
        </div>
      </div>
    </div>
    <div class="null-info" v-if="!followupList.length">
      <img src="@/assets/img/pic_none.png" alt />
      暂无信息...
    </div>
    <followup-modal ref="followupModal" @ok="getFollowup"></followup-modal>
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import { getAction, deleteAction } from "@/api/manage";
import followupModal from "./followupModal";
import videoPlay from "./videoPlay";
import { imgOrVideo } from "@/utils/util";

export default {
  components: {
    followupModal,
    videoPlay,
  },
  data() {
    return {
      defaultAvatar: require("@/assets/img/pic_head_nor.png"),
      url: {
        followup: "/order/api/order/query_order_follow_by_orderid",
      },
      followupList: [],
      orderInfo: {},
    };
  },
  mounted() {
    // this.getFollowup()
  },
  methods: {
    imgOrVideo,
    setPreviewList(list) {
      return list.map((i) => this.imgOrVideo(i).url);
    },
    // 播放视频
    openVideo(item) {
      console.log(item);
      this.$refs.videoPlay.init({ installVideoUrl: item });
    },
    // 获取跟进记录
    getFollowup() {
      getAction(this.url.followup, { orderId: this.$parent.orderid }).then(
        (res) => {
          console.log(res);
          this.followupList = res.data.data;
        }
      );
    },
    // 编辑跟进记录
    editRemark(item) {
      this.$refs.followupModal.edit(this.orderInfo, item);
    },
    // 取消订单
    handleRemove(item) {
      console.log(item);
      this.$confirm("您确定要删除此条跟进记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAction(`/order/api/order/delete_order_follow`, {
            id: item.id,
          }).then((res) => {
            console.log(res);
            if (res.data.code == 0) {
              this.getFollowup();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.null-info {
  background: #fff;
  padding: 30px 261px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #b4b7bc;
  margin-top: 15px;

  img {
    width: 375px;
    height: 94px;
    margin-bottom: 8px;
  }
}
.followup-main {
  // width: calc(100% + 40px);
  // margin-left: -20px;
  .tabel-label {
    display: flex;
    height: 36px;
    background: #f9fafa;
    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #5e6066;
      font-size: 12px;
    }
    .time,
    .logisticsno,
    .orderno {
      width: 192px;
    }
    .followupdata {
      width: 790px;
      justify-content: flex-start;
    }
    .operate {
      width: 120px;
    }
  }
  .tabel-main {
    color: #2f3133;
    padding: 16px 0;
    height: auto;
    background: #fff;
    border-bottom: 1px solid #dfe4eb;
    &:last-child {
      border-bottom: 0;
    }
    a {
      color: #3455d3;
    }
    .followupdata {
      color: #5e6066;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    &/deep/.imgs {
      margin-top: 16px;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      .el-image {
        margin-left: 8px;
        &:first-child {
          margin-left: 0;
        }
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    &/deep/.el-image-viewer__canvas {
      img {
        width: auto !important;
        height: auto !important;
      }
    }
  }
}
</style>
